import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function RevisionModal({ open, onClose, onSuccess, sdpId, token }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    motivo_revisao: "",
    descricao: "",
    liberada_producao: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/sdp/${sdpId}/revisions`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Revisao criada!");
      onSuccess();
      setFormData({ motivo_revisao: "", descricao: "", liberada_producao: false });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao criar revisao");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nova Revisao</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Motivo da Revisao *</Label>
            <Input
              value={formData.motivo_revisao}
              onChange={(e) => setFormData(prev => ({ ...prev, motivo_revisao: e.target.value }))}
              required
              placeholder="Ex: Correcao de dimensoes..."
            />
          </div>
          <div>
            <Label>Descricao das Alteracoes</Label>
            <Textarea
              value={formData.descricao}
              onChange={(e) => setFormData(prev => ({ ...prev, descricao: e.target.value }))}
              rows={3}
              placeholder="Detalhe as alteracoes realizadas..."
            />
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="liberada_producao"
              checked={formData.liberada_producao}
              onCheckedChange={(c) => setFormData(prev => ({ ...prev, liberada_producao: c }))}
            />
            <Label htmlFor="liberada_producao" className="font-normal">
              Liberar para producao
            </Label>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Criando..." : "Criar Revisao"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
